import uiSelectors from 'selectors/ui';
import messageSelectors from 'selectors/messages';
import { getWidgetType } from 'app/modules';
import uiEnums from 'enums/ui';
import updateUnreadMessageCount from 'actions/messages/updateUnreadMessageCount';
import { WIDGET_TYPES } from 'enums/configuration';

export default function computeUnreadMessageCount(dispatch, getState) {
  const state = getState();
  const isMinimized = uiSelectors.getIsMinimized(state.ui);
  const widgetType = getWidgetType(state);
  const isSelfService = widgetType === WIDGET_TYPES.SELF_SERVICE || widgetType === WIDGET_TYPES.DEMO_SELF_SERVICE;
  const isViewingConversation =
    isSelfService && !isMinimized && uiSelectors.getCurrentLocation(state.ui) === uiEnums.LOCATIONS.CHAT;
  const dateMinimized = isSelfService
    ? uiSelectors.getChatLastViewedAt(state.ui)
    : uiSelectors.getminimizedAt(state.ui);

  if ((!isMinimized && !isSelfService) || isViewingConversation) {
    return dispatch(updateUnreadMessageCount(0));
  }

  const messagesAfterDate = messageSelectors.getMessagesAfterDate(state.messages, dateMinimized);
  const agentMessages = messagesAfterDate.filter(m => !m.isUser);

  return dispatch(updateUnreadMessageCount(agentMessages.length));
}
